import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusPill, { StatusVariant } from '../../patterns/StatusPill';

export interface OperatorLicencePillProps {
  /** ISO date string. */
  expiry: string | undefined | null;
}

type Bucket = 'valid' | 'expiringSoon' | 'expired' | 'missing';

function bucketForExpiry(expiry: string | undefined | null): Bucket {
  if (!expiry) return 'missing';
  const ms = new Date(expiry).getTime();
  if (Number.isNaN(ms)) return 'missing';
  const days = (ms - Date.now()) / 86400000;
  if (days < 0) return 'expired';
  if (days <= 30) return 'expiringSoon';
  return 'valid';
}

const VARIANT_BY_BUCKET: Record<Bucket, StatusVariant> = {
  'valid': 'ok',
  'expiringSoon': 'warn',
  'expired': 'danger',
  'missing': 'danger',
};

const OperatorLicencePill: React.FC<OperatorLicencePillProps> = ({ expiry }) => {
  const { t } = useTranslation();
  const bucket = bucketForExpiry(expiry);
  return (
    <StatusPill variant={VARIANT_BY_BUCKET[bucket]}>
      {t(`spray.statusLabels.operatorLicence.${bucket}`)}
    </StatusPill>
  );
};

export default OperatorLicencePill;
